import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';
import { AuthService } from '../../services/auth.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
    username: string = 'Ionut Cosmin Carabat';
    usernameLetters: string = '';
    panelOpenState1 = false;
    panelOpenState2 = false;
    activeRoute = '';
    public isMenuOpen: boolean = false;
    private token: any;
    private isLoading: boolean = false;
    constructor(
        private storageService: StorageService,
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        public permissionsService: PermissionsService,
    ) {
        this.activeRoute = router.url;
    }
    public onSidenavClick(): void {
        // console.log(event);
        this.isMenuOpen = false;
    }
    ngOnInit(): void {
        this.processUserDetails();
    }

    logout() {
        this.router.navigate(['/']);
    }

    processUserDetails() {
        var self = this;
        setTimeout(() => {
            const userObj = self.storageService.getObject(environment.config.userKey);
            userObj
                .then((val) => {
                    self.username = val.name;
                    self.extractLetters(self.username);
                })
                .catch((err) => {
                    self.username = 'Not logged in';
                });
        }, 300);
    }

    extractLetters(username: string) {
        const firstLetters = username.split(' ').map((word) => word.charAt(0));
        this.usernameLetters = firstLetters.slice(0, 2).join('');
    }

    setActiveRoute(value: string) {
        this.activeRoute = value;
    }
}
